import type { FaireProductEntity } from "../../entity_types/product";

export const p_a7d91nlx8a: FaireProductEntity = {
  token: "p_a7d91nlx8a",
  type: "product",
  name: 'Marble U.F.O. 3"',
  brandToken: "b_4e6hayu5vx",
  brandName: "SS handcrafted Art",
  imageUrl:
    "https://cdn.faire.com/fastly/acf6f1d07e2d53429f4d30516c66514832b75d1a07874aa765b4aba90eefa2a4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bca475811e19aab1b676fbcdc26e92537badf2832bf91b42b77de2f851962a43.jpeg",
  ],
  priceDollars: 4.3,
  description:
    "Color variations are expected\n\nSizes are approximate\n\nHandcrafted out of natural marble, in Ecuador\n\nWith every purchase, a portion goes to The Turtleman Foundation to help save one sea turtle at a time",
  tags: [],
  msrpDollars: 8.45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:35.763Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
